/*global jQuery */
/*jshint multistr:true browser:true */
/*!
 * FitVids 1.0.3
 *
 * Copyright 2013, Chris Coyier - http://css-tricks.com + Dave Rupert - http://daverupert.com
 * Credit to Thierry Koblentz - http://www.alistapart.com/articles/creating-intrinsic-ratios-for-video/
 * Released under the WTFPL license - http://sam.zoy.org/wtfpl/
 *
 * Date: Thu Sept 01 18:00:00 2011 -0500
 */

(function( $ ) {

	"use strict";

	$.fn.fitVids = function( options ) {
		var settings = {
			customSelector: null
		};

		if ( !document.getElementById( 'fit-vids-style' ) ) {

			var div       = document.createElement( 'div' ),
				ref       = document.getElementsByTagName( 'base' )[ 0 ] || document.getElementsByTagName( 'script' )[ 0 ],
				cssStyles = '&shy;<style>.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}</style>';

			div.className     = 'fit-vids-style';
			div.id            = 'fit-vids-style';
			div.style.display = 'none';
			div.innerHTML     = cssStyles;

			ref.parentNode.insertBefore( div, ref );

		}

		if ( options ) {
			$.extend( settings, options );
		}

		return this.each( function() {
			var selectors = [
				"iframe[src*='player.vimeo.com']",
				"iframe[src*='youtube.com']",
				"iframe[src*='youtube-nocookie.com']",
				"iframe[src*='kickstarter.com'][src*='video.html']",
				"object",
				"embed"
			];

			if ( settings.customSelector ) {
				selectors.push( settings.customSelector );
			}

			var $allVideos = $( this ).find( selectors.join( ',' ) );

			$allVideos = $allVideos.not( "object object" ); // SwfObj conflict patch
			$allVideos.each( function( i, node ) {
				var $this = $( node );
				if ( this.tagName.toLowerCase() === 'embed' && $this.parent( 'object' ).length || $this.parent( '.fluid-width-video-wrapper' ).length ) {
					return;
				}

				var height      = ( this.tagName.toLowerCase() === 'object' || ($this.attr( 'height' ) && !isNaN( parseInt( $this.attr( 'height' ), 10 ) )) )
						? parseInt( $this.attr( 'height' ), 10 ) : $this.height(),
					width       = !isNaN( parseInt( $this.attr( 'width' ), 10 ) ) ? parseInt( $this.attr( 'width' ), 10 ) : $this.width(),
					aspectRatio = height / width,
					$content    = '';

				if ( !$this.attr( 'id' ) ) {
					var videoID = 'fitvid' + Math.floor( Math.random() * 999999 );
					$this.attr( 'id', videoID );
				}

				if ( typeof videooverlay !== 'undefined' && typeof videooverlay.overlay !== 'undefined' && parseInt( videooverlay.overlay, 10 ) > 0 ) {
					var desctxt   = videooverlay.desctxt || 'By continuing to play this video you accept that in order to provide this free service, we may make your contact details available to the author of the content and that they may contact you.',
						buttontxt = videooverlay.buttontxt || 'Click to play',
						postid    = videooverlay.postid || 0;

					//vovlogg exists so we can overlay
					$content =
						'<div class="fluid-width-video-wrapper-overlay">' +
						'<p class="video-overlay-description">' + desctxt + '</p>' +
						'<a href="#videoPlay" class="button video-overlay-button"  data-post-id="' + postid + '" data-meta-index="' + ( i + 1 ) + '">' + buttontxt + '</a>' +
						'</div>';

				}

				$this
					.wrap( '<div class="fluid-width-video-wrapper"></div>' )
					.parent( '.fluid-width-video-wrapper' )
					.css( 'padding-top', (aspectRatio * 100) + "%" )
					.append( $content );

				$this
					.removeAttr( 'height' )
					.removeAttr( 'width' );
			} );

			// This hooks into any overlay buttons we may have on the site
			$( this ).on( 'mouseup touchend', '.video-overlay-button', function( e ) {
				var $node = $( this ),
					data  = {
						action: 'videooverlay',
						index: 0,
						src: '',
						url: '/admin-ajax.php'
					};

				e.preventDefault();

				// Extract the CSS selectors
				if ( typeof videooverlay === 'object' ) {
					$.extend( data, videooverlay );

					// Clean the ajax url
					data.url = data.url.trim();
				}

				// Grab the video position in the mark-up.
				data.index = $node.data( 'meta-index' );

				// Grab the source
				data.src = $node.parent().siblings( 'iframe' ).attr( 'src' ) || '';

				// We've not logged this click this session?
				if ( $node.data( 'logged' ) !== 'true' ) {
					// This only needs to run once.
					$node.data( { logged: 'true' } );

					// Send the data
					$.ajax( data.url, {
						data: data,
						beforeSend: function() {
							$node.text( 'Checking' ).addClass( 'busy' );
						},
						success: function() {
							$node.text( 'Starting' ).addClass( 'busy' );
							play_video( $node.parent().siblings( 'iframe' ) );
							$node.parent().remove();
						},
						error: function() {
							$node.text( 'Failed' ).addClass( 'error' );
						},
						complete: function() {
							$node.data( { logged: 'done' } );
						}
					} );
				}
			} );
		} );
	};

	function play_video( player ) {
		// Check if we are on vimeo
		if ( player.length > 0 && player.attr( 'src' ).indexOf( 'vimeo' ) > -1 ) {
			var data = {
				method: 'play'
			};

			var message = JSON.stringify( data );
			player[ 0 ].contentWindow.postMessage( message, '*' );
		}
		else if ( player.length > 0 && player.attr( 'src' ).indexOf( 'youtub' ) > -1 ) {
			// Youtube video
		}
		else {
			// Not vimeo or youtube - leave here for later additions

			//console.log( BCLvideoPlayer );


			//var bcExp = brightcove.getExperience('myExperience1150189326001');
			//console.log( APIModules );
			//var modVP = bcExp.getModule('videoPlayer');

			//console.log( bcExp );

			//test
			//var myPlayer = videojs('myExperience1150189326001')

			//player = brightcove.getExperience('myExperience1150189326001');

			//var test = brightcove.getPlayer('myExperience1150189326001');
			//console.log( test );
			//test.play();
		}
	}

	function onYouTubeIframeAPIReady( test ) {
		//console.log( test );
		// player = new YT.Player('player', {
		//     height: '390',
		//     width: '640',
		//     videoId: 'M7lc1UVf-VE',
		//     events: {
		//         'onReady': onPlayerReady,
		//         'onStateChange': onPlayerStateChange
		//     }
		// });
	}


// Works with either jQuery or Zepto
})( window.jQuery || window.Zepto );

